import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  // Polaris parity: 2px focus ring w/ offset. Radius rounded-md (6px) matches
  // Polaris badge radius. Tone variants below express Polaris `tone` prop
  // (success / warning / critical / info / attention) so pages can stop
  // hand-coding Tailwind colour combos for status pills.
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Polaris tone parity — use these instead of hand-coded Tailwind combos
        success:   "border-emerald-200 bg-emerald-50 text-emerald-800",
        warning:   "border-amber-200 bg-amber-50 text-amber-800",
        critical:  "border-rose-200 bg-rose-50 text-rose-800",
        info:      "border-sky-200 bg-sky-50 text-sky-800",
        attention: "border-yellow-200 bg-yellow-50 text-yellow-900",
        new:       "border-violet-200 bg-violet-50 text-violet-800",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
